import { Colors } from '@prezi/dragon';
export var VideoTheme = {
  buttonColor: Colors.purple500,
  buttonColorHover: Colors.purple400,
  buttonBorderColor: Colors.purple400,
  buttonTextColor: Colors.white,
  iconFilterColor: 'invert(27%) sepia(46%) saturate(4059%) hue-rotate(284deg) brightness(99%) contrast(102%);',
  CTABorderRadius: '20px'
};